import { useSelector } from 'react-redux';

function DocuOrde({ onMenuItemClick, iden, solped, typeDocu }) {

	console.log('docuOrde ' + typeDocu);

	const { comp } = useSelector((state) => state.user);
	const currentUrl = window.location.origin;

	const handlePrint = () => {
		const iframe = document.getElementById('iframe_solp');
		iframe.contentWindow.focus();
		iframe.contentWindow.print();
	}

	const copylink = () => {
		navigator.clipboard.writeText(`${currentUrl}?comp=${comp}&doc=${iden}`);
		document.getElementById('copyLabel').innerHTML = 'Enlace copiado';
		setTimeout(() => {
			document.getElementById('copyLabel').innerHTML = 'Copiar enlace';
		}, 2000);
	}


	return (
		<form>
			<main>
				<h1 data-icon=''>Orden de compra {iden}</h1>
				<nav>
					<article>
						<iframe name='iframe_solp' id='iframe_solp' title={`Documento ${typeDocu === 'order' ? 'orden de compra' : 'solicitud'} ${iden}`} src={`${currentUrl}?comp=${comp}&doc=${iden}`} allowFullScreen />
					</article>
				</nav>
			</main>
			<aside>
				<article>
					<h2>Acciones</h2>
					<fieldset>
						<input type="button" onClick={() => onMenuItemClick('listOcDeta', iden, solped, null, typeDocu)} value="Ver datos" />
						<div onClick={() => copylink()} >
							<button onClick={(e) => e.preventDefault()}></button> <label id='copyLabel'>Copiar enlace</label>
						</div>
						<div onClick={() => window.open(`${currentUrl}?comp=${comp}&doc=${iden}`, '_blank')}>
							<button onClick={(e) => e.preventDefault()}></button> <label>Abrir en pestaña</label>
						</div>
						{/* <div onClick={handlePDF}>
							<button onClick={(e) => e.preventDefault()}></button> <label>Exportar a PDF</label>
						</div> */}
						<div onClick={handlePrint}>
							<button onClick={(e) => e.preventDefault()}></button> <label>Imprimir</label>
						</div>
						<input type="button"
							onClick={() =>
								typeDocu === 'order'
									? onMenuItemClick('listInvoice')
									: onMenuItemClick('listSolp')
							}
							value={`Volver a ${typeDocu === 'order' ? 'facturas' : 'solicitudes'}`} />
					</fieldset>
				</article>
			</aside>
		</form>
	);

}
export default DocuOrde;